<template>
  <b-modal
    id="statement-detail-modal"
    v-model="showModal"
    centered
    hide-footer
    dialog-class="statement-detail-modal-dialog"
    content-class="statement-detail-modal-content"
    header-class="statement-detail-modal-header"
    body-class="statement-detail-modal-body"
  >
    <!-- Header -->
    <template #modal-header="{ close }">
      <h5 class="modal-title w-100 text-center">Gerar Demonstrativo</h5>
      <b-button variant="link" class="close-btn p-0" @click="close">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 4L4 12M4 4L12 12" stroke="#212529" stroke-opacity="0.5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </b-button>
    </template>

    <div class="modal-body-container">
      <!-- Seção Produção Médica -->
      <div class="production-info-header mb-3">
        <div class="d-flex align-items-center mb-1">
          <Icon name="icon-producao-medica" class="mr-2" />
          <span class="production-title">{{ modalData.title || 'Produção PF' }}</span>
        </div>
        <div class="value-nf-label">
          Valor NF: <strong class="text-secondary-value">R$ {{ modalData.invoiceValue || '8.148,02' }}</strong>
        </div>
      </div>

      <!-- Resumo Financeiro -->
      <div class="summary-section mb-3">
        <div class="summary-header">Resumo:</div>
        <div class="summary-details-row mt-2">
          <!-- Valor Bruto -->
          <div class="summary-item">
            <div class="item-title">
              <Icon name="icon-valor-bruto" size="16" class="mr-1" />
              <span>Valor bruto:</span>
            </div>
            <div class="item-value">R$ {{ modalData.grossValue || '8.148,02' }}</div>
          </div>

          <!-- Valor Líquido -->
          <div class="summary-item">
            <div class="item-title">
              <Icon name="icon-valor-liquido" size="16" class="mr-1" />
              <span>Valor líquido:</span>
            </div>
            <div class="item-value">R$ {{ modalData.netValue || '6.049,72' }}</div>
          </div>

          <!-- Descontos -->
          <div class="summary-item">
            <div class="item-title">
              <Icon name="icon-descontos" size="16" class="mr-1" />
              <span>Descontos:</span>
            </div>
            <div class="item-value">R$ {{ modalData.discounts || '2.098,30' }}</div>
          </div>

          <!-- Glosas -->
          <div class="summary-item">
            <div class="item-title">
              <Icon name="icon-glosas-2" size="16" class="mr-1" />
              <span>Glosas:</span>
            </div>
            <div class="item-value">R$ {{ modalData.glosses || '0,00' }}</div>
          </div>
        </div>
      </div>

      <!-- Opções de Exportação -->
      <div class="export-options-container">
        
        <!-- CSV -->
        <div class="export-card p-3 mb-2">
          <div class="d-flex align-items-center mb-2">
            <Icon name="icon-csv" size="20" class="mr-2" />
            <span class="export-format-title">CSV</span>
          </div>
          <div class="d-flex">
            <b-button variant="outline-success" class="btn-export" @click="downloadFile('csv', 'receipts')">
              <Icon name="icon-download" size="20" class="mr-1" /> Recebimentos
            </b-button>
          </div>
        </div>

        <!-- XML -->
        <div class="export-card p-3 mb-2">
          <div class="d-flex align-items-center mb-2">
            <Icon name="icon-xml" size="20" class="mr-2" />
            <span class="export-format-title">XML</span>
          </div>
          <div class="d-flex flex-row">
            <b-button variant="outline-success" class="btn-export mr-2" @click="downloadFile('xml', 'summary')">
              <Icon name="icon-download" size="20" class="mr-1" /> Resumo
            </b-button>
            <b-button variant="outline-success" class="btn-export" @click="downloadFile('xml', 'detailed')">
              <Icon name="icon-download" size="20" class="mr-1" /> Detalhado
            </b-button>
          </div>
        </div>

        <!-- PDF -->
        <div class="export-card p-3">
          <div class="d-flex align-items-center mb-2">
            <Icon name="icon-pdf" size="20" class="mr-2" />
            <span class="export-format-title">PDF</span>
          </div>
          <div class="d-flex">
            <b-button variant="outline-success" class="btn-export" @click="downloadFile('pdf', 'receipts')">
              <Icon name="icon-download" size="20" class="mr-1" /> Recebimentos
            </b-button>
          </div>
        </div>

      </div>
    </div>
  </b-modal>
</template>

<script>
import Icon from "../../../components/icon/Icon.vue";

export default {
  name: "StatementDetailModal",
  components: {
    Icon,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    modalData: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    showModal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    downloadFile(format, reportType) {
      this.$emit("download", { format, reportType, data: this.modalData });
    },
  },
};
</script>

<style lang="scss">
.statement-detail-modal-dialog {
  max-width: 800px !important;
  width: 800px;

  @media (max-width: 768px) {
    max-width: 95vw !important;
    width: 95vw !important;
    margin: 10px auto !important;
  }
}

.statement-detail-modal-content {
  border: 1px solid #CED4DA !important;
  border-radius: 6px !important;
  background-color: #FFFFFF !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}

.statement-detail-modal-header {
  height: 64px;
  padding: 20px 32px !important;
  border-bottom: none !important;
  background-color: #FFFFFF !important;
  display: flex !important;
  align-items: center !important;

  @media (max-width: 768px) {
    padding: 16px !important;
    height: 52px;
  }

  .modal-title {
    font-family: 'Trebuchet MS', sans-serif !important;
    font-style: normal !important;
    font-weight: 400 !important;
    font-size: 20px !important;
    line-height: 24px !important;
    color: #212529 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    text-align: center !important;
    margin: 0 !important;

    @media (max-width: 768px) {
      font-size: 18px !important;
    }
  }

  .close-btn {
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
    padding: 0 !important;
  }
}

.statement-detail-modal-body {
  background-color: #FFFFFF !important;
  padding: 0 32px 32px 32px !important;

  @media (max-width: 768px) {
    padding: 0 16px 20px 16px !important;
  }
}
</style>

<style lang="scss" scoped>
.modal-body-container {
  font-family: 'Trebuchet MS', sans-serif;
  background-color: #FFFFFF;

  .production-info-header {
    .production-title {
      font-size: 14px;
      color: #232428;
    }

    .value-nf-label {
      font-size: 16px;
      color: #212529;

      .text-secondary-value {
        color: #00423E;
        font-size: 16px;
        font-weight: 700;
      }
    }
  }

  .summary-section {
    border-top: 1px solid #DFDFDF;
    padding-top: 12px;

    .summary-header {
      font-size: 14px;
      font-weight: 700;
      color: #00423E;
    }

    .summary-details-row {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;

      @media (max-width: 768px) {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 12px;
      }

      .summary-item {
        display: flex;
        flex-direction: column;

        .item-title {
          font-size: 12.8px;
          color: #393C40;
          display: flex;
          align-items: center;
        }

        .item-value {
          font-size: 12px;
          color: #212529;
          margin-top: 2px;
        }
      }
    }
  }

  .export-options-container {
    .export-card {
      border: 1px solid #CED4DA;
      border-radius: 8px;
      background: #FFFFFF;

      .export-format-title {
        font-size: 16px;
        font-weight: 700;
        color: #212529;
      }

      .btn-export {
        height: 36px;
        border: 1px solid #007A4A;
        border-radius: 4px;
        color: #007A4A;
        background-color: transparent;
        font-size: 15px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 6px 16px;
        font-weight: 400;

        @media (max-width: 768px) {
          width: 100%;
        }

        &:hover {
          background-color: #007A4A;
          color: #FFFFFF;
        }
      }
    }
  }
}
</style>